export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const img = (name) => `${API}/static/generated/${name}.png`;

export const SITE = {
  name: 'Ball Raw Performance',
  tagline: 'Claim Your Game.',
  email: 'Support@ballraw.com',
  phone: '(480) 309-3608',
  logoUrl: 'https://customer-assets.emergentagent.com/job_3ce7518b-fbb7-4a75-aa16-34b1c983c084/artifacts/5g8x35mu_ball-raw-files.png',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Corporate Leagues', path: '/corporate-leagues' },
  { label: 'Workforce Systems', path: '/workforce-systems' },
  { label: 'Sports & Resilience', path: '/sports-performance' },
  { label: 'Next Gen Academy', path: '/next-gen-academy' },
  { label: 'Retreat & Events', path: '/retreat-events' },
  { label: 'Partnerships', path: '/partnerships' },
];
